export default __webpack_public_path__ + "static/media/emptyTag.39e2d853.svg";